'use strict';

module.exports = require('./Viewport');


/*****************
 ** WEBPACK FOOTER
 ** ./~/cf-component-viewport/lib/index.js
 ** module id = 372
 ** module chunks = 0
 **/